var MapPool = /** @class */ (function () {
    function MapPool() {
        this.pool = [];
    }
    MapPool.prototype.create = function (construct) {
        var container = function () {
            var dom = document.createElement('div');
            dom.style.height = '100%';
            return dom;
        };
        var instance = this.pool.length
            ? this.pool.pop()
            : construct(container());
        return instance;
    };
    MapPool.prototype.release = function (map) {
        var dom = map.getDiv();
        if (dom.parentNode)
            dom.parentNode.removeChild(dom);
        this.pool.push(map);
    };
    return MapPool;
}());
export { MapPool };
